import React from 'react';
import SeriesCompareScatterChart from '../../components/charts/SeriesCompareScatterChart';
// import SunburstChart from '../../components/charts/SunburstChart';
import { Sunburst, Sankey, LabelSeries } from 'react-vis';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Link } from 'react-router-dom'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
//import FlatButton from '@material-ui/core/FlatButton';
//import RaisedButton from '@material-ui/core/RaisedButton';


class OptimizationAnalyzer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            testMetrics: {},
            pageValueMapNodes: [],
            pageValueMapLinks: [],
            selectedPaths: [],
            open: false,
            hoveredPath: '',
            pathSelectionMessage: ''
            };

        this.handlePageSelected = this.handlePageSelected.bind(this);
        this.handleSunburstMouseOver = this.handleSunburstMouseOver.bind(this);
        this.handleSunburstMouseOut = this.handleSunburstMouseOut.bind(this);
        this.handleSunburstClick = this.handleSunburstClick.bind(this);
    }

    componentDidMount() {
        //this.createVisualization(this.props.data, this.props.width, this.props.height);
    }

    componentDidUpdate() {

    }

    handlePageSelected(item) {
        //load the sunburst for the clicked page
        //console.log(item.payload.testMetrics);

        this.setState({ testMetrics: item.payload.testMetrics });
    }

    handleSunburstMouseOver(arcNode, evt) {

        let thisPath = this.getKeyPath(arcNode).reverse();
        let message = thisPath[thisPath.length-1];

        //render a fixed panel indicating the details
        this.setState({
            hoveredPath : thisPath.map((x) => {return x.title}).join(' > '),
            pathSelectionMessage: 'Trailing VpV: ' + message.trailingEngagementValuePerInteraction
        })
    }

    handleSunburstMouseOut(arcNode, evt) {
        //clear the rendering
    }

    handleSunburstClick(arcNode, evt) {

        var selection = [];
        var thisPath = this.getKeyPath(arcNode).reverse();

        thisPath.shift(); //remove 'root'
        thisPath.shift(); //remove the page

        let selectedPaths = this.state.selectedPaths ? this.state.selectedPaths : [];


        /////// TODO: move to function

        //determine if this path is already in the compare list.
        let pathIsBeingCompared = false;
        selectedPaths.forEach((sourcePath) =>
        {
            let isMatch = true;
            sourcePath.forEach((step, idx) => {
                isMatch = isMatch && step.title === thisPath[idx].title && step.datacategory === thisPath[idx].datacategory;
            });

            pathIsBeingCompared = isMatch;
        });

        if(pathIsBeingCompared)
        {
            return;
        }

        selectedPaths.push(thisPath);
        this.setState({selectedPaths : selectedPaths});
      
        /* 
        for each selected path
            1) add unique set of nodes
            2) map source and target accordingly
        */
        let nodes = [];
        let links = [];
        selectedPaths.forEach((path, idx)=>
        {
            //build nodes - ensure no duplicates are added
            path.forEach((step)=>{
                let srcIdx = nodes.findIndex((element) => {return element.name === step.title && element.key === step.datacategory});
                if(srcIdx == -1)
                {
                    let node =  {
                        name: step.title,
                        color:'',
                        opacity: .75,
                        key: step.datacategory
                    };

                    nodes.push(node);
                }
            })
        })

        // console.log(selectedPaths);
        // console.log(nodes);
        
        //build the links for each path
        selectedPaths.forEach((path, idex)=>
        {
            path.forEach((step, idx)=>
            {
                let srcIdx = nodes.findIndex((element) => {return element.name === step.title && element.key === step.datacategory});
                let nextIdx = idx + 1;
                let targetNode = path[nextIdx];
                if(targetNode)
                {
                    //find the link to the target node in the source node list
                    let targetNodeIdx = nodes.findIndex((element) => {return element.name === targetNode.title && element.key === targetNode.datacategory});
                    //assumes 
                    let link = {
                        source: srcIdx,
                        target: targetNodeIdx,
                        value: step.totalTrailingEngagementValue,
                        color: '', //step.color,
                        opacity: 1,
                        key : step.datacategory
                    };
                
                    links.push(link);
                }
            });

        });

        //console.log(links);

        this.setState({pageValueMapNodes:nodes});
        this.setState({pageValueMapLinks:links});
    }

    /**
     * Recursively work backwards from highlighted node to find path of valud nodes
     * @param {Object} node - the current node being considered
     * @returns {Array} an array of strings describing the key route to the current node
     */
    getKeyPath(node) {
        if (!node.parent) {
            return ['root'];
        }

        var ds  = node.data ? node.data : node;
        
        var o = {
            title : ds.title,
            datacategory: ds.datacategory,
            color: ds.color,
            totalTrailingEngagementValue: ds.totalTrailingEngagementValue,
            interactionCount:ds.interactionCount,
            trailingEngagementValuePerInteraction: ds.trailingEngagementValuePerInteraction
        };

        return [o].concat(this.getKeyPath(node.parent));
    }

    handleOpen = () => {
        this.setState({open: true});
      };
    
      handleClose = () => {
        this.setState({open: false});
      };
    

    render() {
        const { classes } = this.props;
        const { hoveredPath, pathSelectionMessage } = this.state;
        
        const LABEL_STYLE = {
            fontSize: '10px',
            textAnchor: 'middle'
          };
        
        var chart = this.props.data.charts[0];

        // console.log(this.state.pageValueMapNodes);
        // console.log(this.state.pageValueMapLinks);

        console.log(pathSelectionMessage);
        console.log(hoveredPath);

        return (
            <div>

                <Grid container spacing={8}>
                    <Grid item xs={8}>
                        {/* <Paper className={classes.paper}></Paper> */}
                        
                        <SeriesCompareScatterChart 
                            key={chart.id + "_scatter"} 
                            series={chart.series} 
                            onItemClick={this.handlePageSelected} />
                    </Grid>
                    {/* <Grid item xs={4}>
                        <Paper>
                            <h3>#page name#</h3>
                            <div><h4>total visits</h4><span>104</span></div>
                        </Paper>
                    </Grid> */}

                    <Grid item xs={4}>
                        {/* <Paper className={classes.paper}>xs=6</Paper> */}

                        <Sunburst
                            dontRotateLabel
                            hideRootNode
                            animation={false}
                            data={this.state.testMetrics}
                            height={400}
                            width={400}
                            onValueMouseOver={this.handleSunburstMouseOver}
                            onValueMouseOut = {this.handleSunburstMouseOut}
                            onValueClick = {this.handleSunburstClick}
                            style={{
                                stroke: '#ddd',
                                strokeOpacity: 0.3,
                                strokeWidth: '0.5'
                                }}
                            labelStyle ={{
                                    display:'none'
                                }}> 
                            <LabelSeries
                                data={[
                                {x: 0, 
                                 y: 0, 
                                 label: pathSelectionMessage,
                                 style: LABEL_STYLE}]} />
                        </Sunburst>
                        <Paper>
                            <h3>{hoveredPath}</h3>
                        </Paper>

                    </Grid>
                    <Grid item xs={10}>
                        <Sankey
                            nodes={this.state.pageValueMapNodes}
                            links={this.state.pageValueMapLinks}
                            width={1000}
                            height={400}
                            align='justify'
                            layout={1000}
                            style={{
                                labels: {color:'red'},
                                links: {},
                                rects: {}
                              }}
                            />
                    </Grid>
                    <Grid item xs={2}>
                        <Paper>
                            <h3>#page name#</h3>
                            <div><h4>total visits</h4><span>104</span></div>

                            <Button label="Dialog" onClick={this.handleOpen} />
                            <Dialog
                                title="Apply Personalization"
                                modal={false}
                                open={this.state.open}
                                onRequestClose={this.handleClose}>
                                The actions in this window were passed in as an array of React objects.
                                <Button
                                    primary={true}
                                    keyboardFocused={true}
                                    onClick={this.handleClose}>
                                    Apply Personalization
                                </Button>
                            </Dialog>
                        </Paper>

                    </Grid>
                    {/* <Grid item xs={4}>
                        <Paper>
                            <div>profile name</div>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>&nbsp;</TableCell>
                                        <TableCell numeric>Trailing VpV</TableCell>
                                        <TableCell numeric>Visits</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>urban with on-thego feel</TableCell>
                                        <TableCell numeric>400</TableCell>
                                        <TableCell numeric>75</TableCell>
                                    </TableRow>
                                    <TableRow>
                                    <TableCell>test 34 akicle3 aaac</TableCell>
                                        <TableCell numeric>150</TableCell>
                                        <TableCell numeric>46</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>lakidasical feel with personalized city</TableCell>
                                        <TableCell numeric>300</TableCell>
                                        <TableCell numeric>350</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Paper>
                        
                        <Button>Personalize</Button>
                    </Grid> */}
                </Grid>
            </div>
        );
    }
}


export default OptimizationAnalyzer;


// WEBPACK FOOTER //
// ./src/pages/details/OptimizationAnalyzer.js